import Alert from 'components/molecules/Alert';
import Panel from 'components/organisms/Panel';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useModal from '../modal';

export interface ConfirmPanelProps {
    title: string;
    subtitle?: string;
    description: string;
    onConfirm: (id?: string) => void;
    onConfirmLabel?: string;
    onCancel?: (id?: string) => void;
    onCancelLabel?: string;
}

const useConfirmPanel = (props: ConfirmPanelProps): [(id?: string) => void, () => void, boolean] => {
    const [id, setId] = useState<string>();
    const { t } = useTranslation('common');

    const [show, hide, isShowing] = useModal(
        ({ in: inProp, onExited }) => (
            <Panel
                onHide={hide}
                inProp={inProp}
                onExited={onExited}
                title={props.title}
                subtitle={props.subtitle}
                buttons={[
                    { title: props.onCancelLabel ?? t('common:button.save'), onClick: handleOnCancel, isOutline: true },
                    { title: props.onConfirmLabel ?? t('common:button.confirmation'), onClick: handleOnSubmit }
                ]}
                onCloseSide={false}
            >
                <Alert title={props.title} type="warning" description={props.description} />
            </Panel>
        ),
        [id]
    );

    // Methods.
    const handleOnSubmit = () => {
        hide();
        props.onConfirm(id);
    };

    const handleOnCancel = () => {
        hide();
        if (props.onCancel !== undefined) {
            props.onCancel(id);
        }
    };

    const handleShow = (id?: string) => {
        setId(id);
        show();
    };

    return [handleShow, hide, isShowing];
};

export default useConfirmPanel;

